<template>
  <div class="futures">
    <futuresData :noJump="true"></futuresData>

    <el-row :gutter="10" style="margin-top: 20px">
      <el-col :span="4">
        <div class="left-title">选择商品</div>
        <div class="futures-product">
          <div v-for="(item, index) in futuresProducts" 
               :key="index" 
               class="product-item"
               @click="chooseTag(item, index)"
               :class="{'active-product': formSearch.contractCodes.find(tag => tag === item.value)}">
            {{`${item.label}（${item.value}）`}}
          </div>
        </div>
      </el-col>

      <el-col :span="20">
            <el-form :inline="true"
                    :model="formSearch"
                    size="small"
                    class="demo-form-inline">
              <el-form-item>
                <el-input placeholder="请输入代码"
                          v-model.trim="formSearch.contractCode"
                          @change="changeCode"
                          clearable></el-input>
              </el-form-item>
              
              <el-form-item v-if="activeName!='three'">
                <el-date-picker v-model="formSearch.date"
                                type="daterange"
                                range-separator="-"
                                value-format="yyyyMMdd"
                                start-placeholder="日期起"
                                end-placeholder="日期止">
                </el-date-picker>
              </el-form-item>

              <el-form-item>
                <el-button type="primary"
                          @click="handleSearch()">查询</el-button>
              </el-form-item>
            </el-form>

            <div v-if="contractCodes&&contractCodes.length>0" style="padding-bottom:10px;">
              <el-tag
                v-for="(item,i) in contractCodes"
                :key="item.value"
                closable
                @close="doCloseTag(i)" style="margin-right:10px;">
                {{`${item.label}（${item.value}）`}}
              </el-tag>
            </div>

        <el-tabs v-model="activeName" @tab-click="handleSearch">
          <el-tab-pane label="每日交易明细" name="first">
            <listCommon :showEdit="false"
                        :table-list="tariffsArray"
                        :columnList="columnArray"
                        :show-order="true"
                        :border="false"
                        :showPopover="false"
                        :stripe="true"
                        tableId="boxed"
                        ref="tab"
                        :isRightExpand="true"
                        :orderNofixed="true"
                        :showOrder="false"
                        @expand-change="handelExpandChange">
              <template slot="contractCode" slot-scope="prop">
                <span class="contract-code" @click="intoCode(prop.row)">{{prop.row.contractCode}}</span>
              </template>
            
              <template slot="rate" slot-scope="prop">
                <span class="table-cell-span"
                      v-if="Number(prop.row.yesterdaySettle) && Number(prop.row.todaySettle)"
                      :style="{color: Number(prop.row.todaySettle) < Number(prop.row.yesterdaySettle) ? 'green' :
                                      Number(prop.row.todaySettle) > Number(prop.row.yesterdaySettle) ? 'red' : ''}">
                  {{Number(((prop.row.todaySettle - prop.row.yesterdaySettle) / prop.row.yesterdaySettle * 100).toFixed(2))}}%
                </span>
              </template>

              <template slot="rightExpand" slot-scope="prop">
                <priceTrend ref="priceTrend"
                            :trendItem="prop.row"
                            :chartId="prop.row.id + ''"></priceTrend>
              </template>
            </listCommon>
          </el-tab-pane>
          <el-tab-pane label="未来行情趋势图" name="second">
            <div class="chart-list">
              <div class="chart-item" v-for="(item, i) in tariffsArray" :key="i">
                <priceTrend ref="priceTrend"
                            :trendItem="item"
                            :chartId="item.contractCode + ''" v-if="activeName=='second'"></priceTrend>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="品种走势" name="three">
            <div class="chart-list" style="min-height: 500px" v-loading="loadState">
              <div class="chart-item" v-for="(item, i) in tariffsArray2" :key="i">
                <priceTrend2 v-if="item.data_list&&item.data_list.length>0" 
                  :trendItem="item.data_list"
                  :title="item.title"
                  :yTitle="item.label+'（'+item.value+'）'"
                  :chartId="item.value"></priceTrend2>
              </div>
            </div>
          </el-tab-pane>
          <el-pagination
            background
            style="float: right;margin-top: 10px"
            layout="prev, pager, next"
            :total="total"
            :current-page="currentPage"
            :page-size="pageSize"
            @size-change="sizeChange"
            @current-change="currentChange">
          </el-pagination>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import listCommon from './components/list-common'
import priceTrend from './components/line-chart'
import priceTrend2 from './components/line-chart2'
import futuresData from './components/futures-data'
import { getCookie } from '../utils/index.js';

var defaultColumns = [
  {
    props: 'contractCode',
    labels: '合约代码',
    widths: 70,
    slot: true
  },
  {
    props: 'bizDate',
    labels: '交易日期',
    widths: 80
  },
  {
    props: 'yesterdaySettle',
    labels: '昨结算',
    widths: 80,
    align: 'right'
  },
  {
    props: 'todaySettle',
    labels: '今结算',
    widths: 80,
    align: 'right'
  },
  {
    props: 'rate',
    labels: '涨跌幅',
    widths: 60,
    slot: true,
    align: 'right'
  },
  {
    props: 'todayOpening',
    labels: '今开盘',
    widths: 80,
    align: 'right'
  },
  {
    props: 'maxPrice',
    labels: '最高价',
    widths: 80,
    align: 'right'
  },
  {
    props: 'minPrice',
    labels: '最低价',
    widths: 80,
    align: 'right'
  },
  {
    props: 'todayClosing',
    labels: '今收盘',
    widths: 80,
    align: 'right'
  },
  {
    props: 'openInterest',
    labels: '持仓量',
    widths: 80,
    align: 'right'
  },
  {
    props: 'quantity',
    labels: '增减量',
    widths: 80,
    align: 'right'
  },
  {
    props: 'amount',
    labels: '成交额(万元)',
    widths: 100,
    align: 'right'
  },
]

export default {
  name: 'futures',
  components: { listCommon, priceTrend, priceTrend2, futuresData },
  data () {
    return {
      loadState: false,
      lastDate: {
        year: '',
        day: ''
      },
      activeName: 'first',
      contractCodes: [],
      futuresProducts: [],
      tariffsArray: [], // 列表数据
      tariffsArray2: [],
      columnArray: defaultColumns, // 表头数组
      currentPage: 1,
      pageSize: 30,
      total: 0,
      formSearch: {
        contractCodes: [],
        date: []
      },
    }
  },
  watch: {},
  mounted () {
    this.getByTypes()
    // this.handleSearch()

    document.addEventListener('keydown', this.disablePrintScreen);
    document.addEventListener('contextmenu', this.disableContextMenu);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.disablePrintScreen);
    document.removeEventListener('contextmenu', this.disableContextMenu);
  },
  methods: {
    doCloseTag(i) {
      var item = this.contractCodes[i];
      this.contractCodes.splice(i, 1);
      var contractCodes = this.formSearch.contractCodes;
      contractCodes = contractCodes.filter(t => t != item.value);
      this.$set(this.formSearch, 'contractCodes', contractCodes);
      
      this.handleSearch()
    },
    disablePrintScreen(event) {
      // 阻止快捷键：Print Screen
      if (event.keyCode === 44 && event.ctrlKey) {
        event.preventDefault();
      }
      if (event.altKey) {
        event.preventDefault();
      }
      if (event.key === 'PrintScreen' || event.keyCode === 44) {
        event.preventDefault();
      }
    },
    disableContextMenu(event) {
      // 阻止右键菜单
      event.preventDefault();
    },
    intoCode (row) {
      if (row.sinaFuturesUrl) {
        window.open(row.sinaFuturesUrl)
      }
    },
    handleSearch () {
      this.currentPage = 1
      this.getListData()
    },
    changeCode () {
      this.$set(this.formSearch, 'contractCodes', []);
    },
    // 点击标签
    chooseTag (item, index) {
      var contractCodes = this.contractCodes||[];
      if (contractCodes.map(t => { return t.value }).indexOf(item.value) == -1) {
        contractCodes.push(item)
      }
      this.contractCodes = contractCodes;
      this.$set(this.formSearch, 'contractCodes', contractCodes.map(t => {
        return t.value
      }))
      
      this.handleSearch()
    },
    getByTypes () {
      this.$http({
        url: this.$http.adornUrl('/crmapi/bas/bulkFutures/productCategory'),
        method: 'get',
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.futuresProducts = data.result || []
          if (this.$route.query.contractCode) {
            let res = this.futuresProducts.find(item => this.$route.query.contractCode.includes(item.value))
            if (res) {
              this.$set(this.formSearch, 'contractCode', res.value)
            } else {
              this.$set(this.formSearch, 'contractCode', this.$route.query.contractCode)
            }
          }
          this.handleSearch()
        } else {
          this.$message.error(data.message)
          this.handleSearch()
        }
      }).catch(() => {
        this.handleSearch()
      })
    },
    // 获取数据列表
    getAllListData () {
      let labels = (this.formSearch.contractCodes||[]).join(',')
      this.loadState = true
      this.tariffsArray2 = []
      this.$http({
        url: this.$http.adornUrl('/crmapi/bas/bulkFutures/listAll'),
        method: 'post',
        data: {
          pageNum: this.currentPage,
          pageSize: 10,
          data: {
            labels,
            startDate: this.formSearch.date?this.formSearch.date[0]:null,
            endDate: this.formSearch.date?this.formSearch.date[1]:null,
            contractCodes: this.formSearch.contractCodes||[],
            contractCode: this.formSearch.contractCode
          },
          params: {
            // contractCode$LIKE: labels ? labels : this.formSearch.contractCode,
          }
        }
      }).then((res) => {
        if (res.data && res.data.code === 'C0000') {
          let array = res.data.result.list || []
          this.tariffsArray2 = array.map(t => {
            var arr = this.futuresProducts.filter(s=>s.value==t.extracted_letters);
            if (!arr || arr.length == 0) {
              arr = [{
                label: t.extracted_letters,
                value: t.extracted_letters
              }];
            }
            var title = ''
            if (t.data_list && t.data_list.length > 0) {
              title = t.data_list[0].bizDate.substr(0, 4)+'-'+t.data_list[0].bizDate.substr(4, 2)+'-'+t.data_list[0].bizDate.substr(6, 2);
            }
            return {
              data_list: t.data_list,
              label: arr[0].label,
              value: arr[0].value,
              title: title
            }
          })

          this.total = res.data.result.total
          this.loadState = false
        } else {
          this.$message.error(res.data.message)
          this.loadState = false
        }
      }).finally(() => {
        this.loadState = false
      })
    },
    // 获取数据列表
    getListData () {
      if (this.activeName == 'three') {
        this.getAllListData()
        return;
      }
      let labels = (this.formSearch.contractCodes||[]).join(',')
      this.loadState = true
      this.$http({
        url: this.activeName == 'second' ? this.$http.adornUrl('/crmapi/bas/bulkFutures/listCode') : this.$http.adornUrl('/crmapi/bas/bulkFutures/list'),
        method: 'post',
        data: {
          pageNum: this.currentPage,
          pageSize: this.activeName == 'second' ? 10 : this.pageSize,
          data: {
            labels,
            startDate: this.formSearch.date?this.formSearch.date[0]:null,
            endDate: this.formSearch.date?this.formSearch.date[1]:null,
            contractCodes: this.formSearch.contractCodes||[],
            contractCode: this.formSearch.contractCode
          },
          params: {
            // contractCode$LIKE: labels ? labels : this.formSearch.contractCode,
          }
        }
      }).then((res) => {
        if (res.data && res.data.code === 'C0000') {
          let array = res.data.result.list || []
          this.tariffsArray = array

          if (this.$route.query.showChart) {
            let row = this.tariffsArray.find(item => item.contractCode === this.$route.query.contractCode)
            if (row) this.$refs.tab.$refs.mulTable.toggleRowExpansion(row, true)
          }
          this.total = res.data.result.total
          this.loadState = false
        } else {
          this.$message.error(res.data.message)
          this.loadState = false
        }
      }).finally(() => {
        this.loadState = false
      })
    },
    sizeChange (size) {
      this.pageSize = size
      this.getListData()
    },
    handelExpandChange(e) {
      if (!getCookie('userId')) {
        this.$confirm('请先登录系统或申请试用!', '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '登录',
          cancelButtonText: '申请试用',
          type: 'warning'
        }).then(() => {
          location.href = "http://iportal.zhongpukeji.cn/#/login";
        }).catch((action) => {
          if (action == 'close') return;
          location.href = "http://iportal.zhongpukeji.cn/#/trial";
        });
        e.table.toggleRowExpansion(e.row, false);
        return;
      }
    },
    currentChange (currPage) {
      if (!getCookie('userId')) {
        this.$confirm('请先登录系统或申请试用!', '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '登录',
          cancelButtonText: '申请试用',
          type: 'warning'
        }).then(() => {
          location.href = "http://iportal.zhongpukeji.cn/#/login";
        }).catch((action) => {
          if (action == 'close') return;
          location.href = "http://iportal.zhongpukeji.cn/#/trial";
        });
        return;
      }
      this.currentPage = currPage
      this.getListData()
    },
  }
}
</script>
<style lang="scss">
.chart-list {
  overflow: hidden;
  .chart-item {
    width: 50%;
    overflow: hidden;
    float: left;
  }
}
.futures {
  max-width: 1280px;
  margin: auto;
  padding: 0 0 20px;
  background: #fff;
  font-size: 14px;
  -webkit-user-select: none; /* Chrome, Safari, Opera */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+ */
  user-select: none; /* Standard syntax */

  .left-title{
    background: #EBEEF5;
    color: #1d74ff;
    padding: 10px;
    text-align: center;
  }
  .futures-product{
    background: #DCDFE6;
    padding: 10px 0;
    margin-top: 6px;
    .product-item{
      padding: 10px 20px;
      cursor: pointer;
    }
    .active-product{
      color: #1d74ff;
      text-decoration: underline;
    }
    .product-item:hover{
      text-decoration: underline;
    }
  }
}
.contract-code{
  color: #3874F6;
  text-decoration: underline;
  cursor: pointer;
}
.expand_icon{
  .el-icon{
    color: #3874F6;
    font-size: 18px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/futures.vue